module.exports = new __parcel__URL__("66522_h.6954afc9.jpg").toString();